<template>
  <div ref="chatContainer" class="tw:overflow-y-auto">
    <ChatInitialMessage />
    <ul class="tw:mt-7">
      <li
        v-for="message in chatMessages"
        :key="message.id"
        :class="message.author === authors.FEEDBACK ? 'tw:mb-4' : 'tw:mb-7'">
        <ChatMessage
          v-if="message.author !== authors.FEEDBACK"
          :text="message.text"
          :author="message.author"
          :timestamp="message.timestamp" />
        <ChatFeedbackMessage
          v-if="message.author === authors.FEEDBACK"
          :id="message.id"
          :status="message?.feedbackStatus"
          class="tw:mb-7" />
      </li>

      <div v-show="isAwaitingReply">
        <div class="tw:flex tw:items-center">
          <ArtificialIntelligenceIcon class="tw:inline tw:relative tw:bottom-0.5 tw:mr-1 tw:size-6" />
          <SmallDotLoader color="#000" />
        </div>
      </div>
    </ul>
  </div>
</template>

<script setup>
import { ref, watchEffect, nextTick, onMounted, onBeforeUnmount } from 'vue'

import ChatInitialMessage from '@/components/chatbot/ChatInitialMessage.vue'
import ChatMessage from '@/components/chatbot/ChatMessage.vue'
import SmallDotLoader from '@/components/base/loaders/SmallDotLoader.vue'
import ArtificialIntelligenceIcon from '@/components/icons/ArtificialIntelligenceIcon.svg?component'
import useChat, { authors } from '@/components/chatbot/useChat'
import appAnalytics from '@/utils/tracking'
import ChatFeedbackMessage from './ChatFeedbackMessage.vue'

const { chatMessages, isAwaitingReply, conversationId } = useChat()

const chatContainer = ref(null)

const scrollToBottom = () => {
  if (!chatContainer.value) return

  chatContainer.value.scrollTo({
    top: chatContainer.value.scrollHeight,
    behavior: 'smooth',
  })
}

watchEffect(async () => {
  if (chatMessages.value.length > 0) {
    await nextTick()
    scrollToBottom()
  }
})

const handleLinkClick = event => {
  const link = event.target.closest('a[data-link="true"]')

  if (link) {
    const url = link.getAttribute('href')
    const text = link.textContent
    appAnalytics.track(appAnalytics.events.CHAT_LINK_CLICKED, {
      conversation_id: conversationId.value,
      link_url: url,
      link_text: text,
    })
  }
}

onMounted(() => {
  chatContainer.value?.addEventListener('click', handleLinkClick)
})

onBeforeUnmount(() => {
  chatContainer.value?.removeEventListener('click', handleLinkClick)
})
</script>
